import { useState } from "react";

import { useFieldArray, useFormContext } from "react-hook-form";
import * as XLSX from "xlsx";

import { Folder as FolderIcon } from "@mui/icons-material";
import { Button, Paper, Typography } from "@mui/material";

import { StatusEnum, statusLabels } from "../../shared";

const UploadTemplateSection = () => {
  const { control, setValue } = useFormContext();
  const [uploadedFilename, setUploadedFilename] = useState(null);

  const { replace } = useFieldArray({
    control,
    name: "productVariants",
  });

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setUploadedFilename(file.name);
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Sheet 1: Product Info
      const productInfoSheet = workbook.Sheets["Product Info"];
      const productInfoData = XLSX.utils.sheet_to_json(productInfoSheet);
      if (productInfoData.length > 0) {
        setValue("name", productInfoData[0].name);
        setValue("stockKeepingUnitPrefix", productInfoData[0].SKU);
      }

      // Sheet 2: Information about the variant attributes
      const variantAttributesSheet = workbook.Sheets["Variant Attributes"];
      const variantAttributesData = XLSX.utils.sheet_to_json(
        variantAttributesSheet
      );

      // Sheet 3: Combinations of product variants
      const productVariantsSheet = workbook.Sheets["Product Variants"];
      const productVariantsData =
        XLSX.utils.sheet_to_json(productVariantsSheet);

      const variantAttributes = variantAttributesData.map((attr) => ({
        attribute: { id: attr.id, name: attr.name },
        values: attr.values.split(", ").map((value) => value.trim()),
      }));

      setValue("variantAttributes", variantAttributes);

      const attributeIds = variantAttributesData.reduce((acc, attr, index) => {
        acc[attr.name] = `variantAttribute${index + 1}Id`;
        return acc;
      }, {});

      const productVariants = productVariantsData.map((combination) => {
        const parsedRetailPrice = Number(combination.retailPrice);
        const parsedDistributorPrice = Number(combination.distributorPrice);

        const productVariant = {
          name: combination.name,
          sku: combination.SKU,
          retailPrice: isNaN(parsedRetailPrice) ? 0 : parsedRetailPrice,
          distributorPrice: isNaN(parsedDistributorPrice)
            ? 0
            : parsedDistributorPrice,
          status: combination.status === statusLabels[StatusEnum.ACTIVE],
        };

        Object.keys(attributeIds).forEach((attrName, index) => {
          productVariant[attributeIds[attrName]] =
            variantAttributesData[index].id;
          productVariant[`variantAttribute${index + 1}Value`] =
            combination[attrName];
        });

        return productVariant;
      });

      replace(productVariants);
    };
    reader.readAsArrayBuffer(file);

    // Reset the file input value
    event.target.value = "";
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mt: 3,
        border: "1px solid #ccc",
      }}
    >
      <Typography variant="body1" sx={{ fontWeight: 500 }}>
        Upload Template
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Pilih file Excel yang sudah kamu masukkan varian produk-nya disini.
      </Typography>
      <input
        type="file"
        accept=".xlsx"
        onChange={handleFileUpload}
        style={{ display: "none" }}
        id="upload-xlsx"
      />
      <label htmlFor="upload-xlsx">
        <Button
          fullWidth
          variant="outlined"
          startIcon={<FolderIcon />}
          sx={{ mt: 3 }}
          component="span"
        >
          Pilih File
        </Button>
      </label>
      {uploadedFilename && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          Filename: {uploadedFilename}
        </Typography>
      )}
    </Paper>
  );
};

export default UploadTemplateSection;
